import { useTranslation } from 'react-i18next';

const GROUP_IMAGES = [
  [
    '/images/generated/textbook-01-2026.jpg',
    '/images/generated/textbook-02-2026.jpg',
    '/images/generated/textbook-03-2026.jpg',
    '/images/generated/textbook-04-2026.jpg',
    '/images/generated/textbook-05-2026.jpg',
  ],
  [
    '/images/generated/textbook-a1-2026.jpg',
    '/images/generated/textbook-a2-2026.jpg',
    '/images/generated/textbook-a3-2026.jpg',
    '/images/generated/textbook-a4-2026.jpg',
    '/images/generated/textbook-a5-2026.jpg',
  ],
  [
    '/images/generated/textbook-m1-2026.jpg',
    '/images/generated/textbook-m2-2026.jpg',
    '/images/generated/textbook-m3-2026.jpg',
    '/images/generated/textbook-m4-2026.jpg',
    '/images/generated/textbook-m5-2026.jpg',
  ],
];

export default function TextbookLineup() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-primary-900">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('materials.books.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-400 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-50 tracking-[0.06em] mb-2">
            {t('materials.books.title')}
          </h2>
          {String(t('materials.books.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-400 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto"></div>
          {String(t('materials.books.description')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-300 tracking-[0.04em] leading-relaxed mt-5 max-w-[600px] mx-auto">{__s}</p>))}
        </div>

        <div className="space-y-16">
          {GROUP_IMAGES.map((images, gIdx) => (
            <div key={gIdx}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-6 pb-3 border-b border-white/10">
                <h3 className="font-heading text-[17px] text-foreground-50 tracking-[0.05em]">
                  {t(`materials.books.groups.${gIdx}.title`)}
                </h3>
                <span className="text-[13px] text-accent-400 tracking-[0.04em]">
                  {t(`materials.books.groups.${gIdx}.note`)}
                </span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {images.map((src, idx) => (
                  <div
                    key={idx}
                    className={`card-glow group bg-primary-800/60 border border-primary-700/50 p-6 cursor-pointer ${
                      idx >= 3 ? 'lg:col-span-1' : ''
                    } ${idx === 3 ? 'sm:col-span-2 lg:col-span-1' : ''}`}
                  >
                    <div className="flex items-start gap-4 mb-4">
                      <span className="font-heading text-3xl text-accent-500/40 group-hover:text-accent-400/60 transition-colors flex-shrink-0 leading-none mt-1">
                        {t(`materials.books.groups.${gIdx}.books.${idx}.code`)}
                      </span>
                      <div>
                        <h3 className="font-heading text-[17px] text-foreground-100 tracking-[0.05em] mb-1 group-hover:text-accent-400 transition-colors leading-snug">
                          {t(`materials.books.groups.${gIdx}.books.${idx}.title`)}
                        </h3>
                        <p className="section-title-en text-accent-500 text-[13px] tracking-[0.08em]">
                          {t(`materials.books.groups.${gIdx}.books.${idx}.titleEn`)}
                        </p>
                      </div>
                    </div>

                    <div className="mb-4">
                      <img
                        src={src}
                        alt={t(`materials.books.groups.${gIdx}.books.${idx}.imgAlt`)}
                        className="w-full aspect-[4/3] object-cover object-top bg-primary-800/40"
                      />
                    </div>

                    <p className="text-[14px] text-foreground-400 tracking-[0.03em] leading-relaxed">
                      {t(`materials.books.groups.${gIdx}.books.${idx}.description`)}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {String(t('materials.books.imgNote')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-center text-[14px] text-foreground-500 tracking-[0.04em] mt-8">{__s}</p>))}
      </div>
    </section>
  );
}
